import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrimValueAccessorDirective } from '../../directives/trim-value-accessor/trim-value-accessor.directive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxEditorModule } from 'ngx-editor';
import { ManagedTooltipDirective } from '../../directives/managed-tooltip.directive';
import { AppTooltipDirective } from '../../directives/app-tooltip.directive';
import { TourGuideTooltipComponent } from '../tour-guide-tooltip/tour-guide-tooltip.component';
import { TooltipConfigModalComponent } from '../tooltip-config-modal/tooltip-config-modal.component';
import { TooltipAdminToolbarComponent } from '../tooltip-admin-toolbar/tooltip-admin-toolbar.component';
import { SimpleSelectModule } from '../simple-select/simple-select.module';
import { StripHtmlPipe } from '../../_pipes/strip-html.pipe';

@NgModule({
  declarations: [
    ManagedTooltipDirective,
    AppTooltipDirective,
    TourGuideTooltipComponent,
    TooltipConfigModalComponent,
    TooltipAdminToolbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TrimValueAccessorDirective,
    ModalModule,
    NgxEditorModule,
    SimpleSelectModule,
    StripHtmlPipe
  ],
  exports: [
    ManagedTooltipDirective,
    AppTooltipDirective,
    TourGuideTooltipComponent,
    TooltipConfigModalComponent,
    TooltipAdminToolbarComponent
  ]
})
export class TourGuideTooltipModule {}
